<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">
      <slide>
          <div class="padding">
          <p>so i don't really know why i'm writing this, i've never kept a diary,<br>
          i've never really written down my thoughts,<br>
          i've definitely never written a letter,<br>
          and yet now i find myself writing to you,<br>
          even though to be honest i'm not sure who you are<br></p>

          <p>It's hard to explain but i feel like you should be here, and i feel like i should know who you are, the strangest thing is that other people seem to think this too, strangers even.</p>

          <p>In the coffee shop this afternoon they said 'on your own today?' . . and i didn't really know what they meant, so i just smiled and did my best to nod and laugh.</p>

          <p>Looking at what I've just written doesn't help, I feel like I'm talking nonsense, and i should see someone about it. but really somehow it gives me comfort imagining, imagining something like this, someone like this, someone I could have known. Oska fills my life of course, I would never say we want for anything, and still . . .</p>

          <p>Who are you? I can't picture you, I can't describe you, and yet I know I miss you. In my father's final years he developed a form of dementia, an after effect of years of spacing they said. His memory was on a loop, he repeated himself over and over and over again, by the end he had almost completely forgotten who I was.</p>

          <p>As it got worse I thought it might actually be making things easier for him, but then he would say to 'there's something wrong with me, but i don't know what it is' , and this unknowing was tearing him up inside, there was a knowledge just out of his grasp, just out of his sight, and he was never going to reach it.</p>

          <p>sometimes...</p>
          </div>
      </slide>

      <slide>
          <div class="padding">
          <p>when i wake up</p>
          </div>
      </slide>

      <slide>
          <div class="padding">
          <p>i expect you</p>
          </div>
      </slide>

      <slide>
          <div class="padding">
          <p>to be there beside me</p>
          </div>
      </slide>

      <slide>
          <div class="padding">
          <p>the rooms are too quiet</p>
          </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '3',

  data () {
    return {
      title: 'My Father'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
